<template>
  <div class="pl-2 pr-2">
    <div id="gantt-header" class="h-12 p-2 flex items-center gap-2">
      <h1 class="text-xl font-bold" style="margin-right: 10px;">KERP Time Gantt</h1>
      <button @click="addTask" class="bg-indigo-700 hover:bg-indigo-900 text-white py-2 px-4 rounded-lg flex items-center">
        <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <span class="font-bold text-xs">タスクを追加する</span>
      </button>
      <div class="flex items-center">
        <label class="text-xs ml-4 mr-2">開始日:</label>
        <Datepicker
            v-model="selectedStartDate"
            date-picker
            locale="ja"
            class="text-xs"
            auto-apply
            :enable-time-picker="false"
            style="width: 150px;"
            :clearable="false"
            :format="formatDate"
        />
      </div>

      <div class="flex items-center">
        <label class="text-xs ml-4 mr-2">終了日:</label>
        <Datepicker
            v-model="selectedEndDate"
            date-picker
            locale="ja"
            class="text-xs"
            auto-apply
            :enable-time-picker="false"
            style="width: 150px;"
            :clearable="false"
            :format="formatDate"
        />
      </div>

      <CTimeEditForm
        :showDialog="showDialog"
        :update_mode="update_mode"
        :form="form"
        :errors="errors"
        :apiErrorMsg="apiErrorMsg"
        :loading="loading"
        @save="saveTask"
        @update="updateTask"
        @delete="deleteTask"
        @close="showDialog = false"
        @change="onFormChange"
      />
    </div>

    <div style="padding: 0 10px">
      <p v-if="apiErrorMsgForHome" style="color: #bf0000; font-size: 20px">{{apiErrorMsgForHome}}</p>
    </div>

    <CGanttChartTime
      :tasks-list="tasks"
      :clickable="true"
      :resizable="true"
      :draggable="true"
      :auto-scroll="false"
      :start-date="selectedStartDate"
      :end-date="selectedEndDate"
      :block_size="40"
      @editTask="editTask"
      @taskUpdated="updateDraggedTask"
    />
  </div>
</template>

<script>
import CGanttChartTime from '@/components/CGanttChartTime.vue'
import CTimeEditForm from '@/components/CTimeEditForm.vue'
import apiUrl from "@/const/apiUrl";
import config from "@/prm/Pgreenctasksbytime"
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: { CGanttChartTime, CTimeEditForm, Datepicker },
  data() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    return {
      actl: config.actl,
      aaction: config.aaction,
      saveUrl: config.add,
      editUrl: config.edit,
      deleteUrl: config.delete,
      selectedStartDate: null,
      selectedEndDate: null,
      tasks: [],
      showDialog: false,
      form: {
        id: '',
        name: '',
        worker_name: '',
        task_date: todayStr,
        start_time: '',
        end_time: '',
        break_start_time: '',
        break_end_time: '',
      },
      update_mode: false,
      errors: {},
      apiErrorMsg: '',
      loading: false,
      apiErrorMsgForHome: '',
      nextId: 6,
      selectedItemId: null,
      formatDate(date) {
        if (!date) return ''
        // format as YYYY-MM-DD
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
    }
  },
  mounted() {
    this.loadData()
    this.selectedStartDate = new Date()
  },
  methods: {
    loadData() {
      const url = apiUrl + this.actl + '/' + this.aaction + '.json'
      this.$axios.get(url)
          .then(response => {
            console.log('response', response)
            if (response.status === 200 && Object.prototype.hasOwnProperty.call(response.data, 'list')) {
              response.data.list.forEach(element => {
                const task = this.prepareTaskData(element)
                this.tasks.push(task)
              })
            }
          })
          .catch(error => {
            console.log('error', error)
          })
    },
    onFormChange(payload) {
      const { field, value } = payload || {};
      if (!field) return;
      this.form = { ...this.form, [field]: value };
    },
    editTask(task) {
      this.update_mode = true;
      this.showDialog = true;
      this.form = { ...task };
      this.apiErrorMsg = '';
      this.errors = {};
    },
    addTask() {
      this.update_mode = false;
      this.form = {
        name: '',
        worker_name: '',
        task_date: this.$moment().format('YYYY-MM-DD'),
        start_time: '',
        end_time: ''
      };
      this.showDialog = true;
      this.apiErrorMsg = '';
      this.errors = {};
    },
    formValidation() {
      this.errors = {};

      // Task name and date validations
      if (!this.form.name) this.errors.name = 'タスク名は必須です。';
      if (!this.form.task_date) this.errors.task_date = '日付は必須です。';

      // Start time & End time validations
      if (this.form.start_time === null || this.form.start_time === undefined || this.form.start_time === '') {
        this.errors.start_time = '開始時間は必須です。';
      }
      if (this.form.end_time === null || this.form.end_time === undefined || this.form.end_time === '') {
        this.errors.end_time = '完了時間は必須です。';
      }

      let startM = null;
      let endM = null;

      if (this.form.start_time && this.form.end_time) {
        const [sh, sm] = this.form.start_time.split(':').map(Number);
        const [eh, em] = this.form.end_time.split(':').map(Number);

        startM = sh * 60 + sm;
        endM = eh * 60 + em;

        if (startM >= endM) {
          this.errors.start_time = '開始時間は完了時間より前である必要があります。';
          this.errors.end_time = '完了時間は開始時間より後である必要があります。';
        }
      }

      // Break Start Time validation
      if (this.form.break_start_time !== null && this.form.break_start_time !== undefined && this.form.break_start_time !== '') {
        if (startM === null || endM === null) {
          this.errors.break_start_time = '開始時間と完了時間を先に設定してください。';
        } else {
          const [bsh, bsm] = this.form.break_start_time.split(':').map(Number);
          const breakStartM = bsh * 60 + bsm;

          if (breakStartM < startM || breakStartM > endM) {
            this.errors.break_start_time = '休憩開始は開始時間と完了時間の間である必要があります。';
          }
          if (this.form.break_end_time) {
            const [beh, bem] = this.form.break_end_time.split(':').map(Number);
            const breakEndM = beh * 60 + bem;
            if (breakStartM > breakEndM) {
              this.errors.break_start_time = '休憩開始は休憩終了より前である必要があります。';
            }
          }
        }
      }

      // Break End Time validation
      if (this.form.break_end_time !== null && this.form.break_end_time !== undefined && this.form.break_end_time !== '') {
        if (startM === null || endM === null) {
          this.errors.break_end_time = '開始時間と完了時間を先に設定してください。';
        } else {
          const [beh, bem] = this.form.break_end_time.split(':').map(Number);
          const breakEndM = beh * 60 + bem;

          if (breakEndM < startM || breakEndM > endM) {
            this.errors.break_end_time = '休憩終了は開始時間と完了時間の間である必要があります。';
          }
          if (this.form.break_start_time) {
            const [bsh, bsm] = this.form.break_start_time.split(':').map(Number);
            const breakStartM = bsh * 60 + bsm;
            if (breakEndM < breakStartM) {
              this.errors.break_end_time = '休憩終了は休憩開始より後である必要があります。';
            }
          }
        }
      }

      return Object.keys(this.errors).length > 0;
    },
    saveTask() {
      if (this.formValidation()) return;
      this.loading = true;
      const url = apiUrl + this.actl + '/' + this.saveUrl + '.json'
      const postData = this.preparePostData(this.form)
      this.$axios.post(url, postData)
        .then(response => {
          console.log('response', response)
          const responseData = response.data.response
          if (response.status === 200 && responseData.status === true) {
            console.log('prepare task data', this.prepareTaskData(responseData.data))
            this.tasks.push(this.prepareTaskData(responseData.data))
          }else {
            this.apiErrorMsg = responseData.msg
          }
        })
        .catch(error => {
          console.log('error', error)
        })
        .finally(() => {
          this.loading = false;
          this.showDialog = false;
          this.form = {};
        })

    },
    prepareTaskData(data) {
      const normalizeTime = (val) => {
        if (!val) return '';
        const match = val.match(/T(\d{2}:\d{2})/);
        return match ? match[1] : val;
      };
      if (data) {
        return {
          id: data.id,
          name: data.name,
          worker_name: data.worker_name,
          task_date: this.$moment(data.task_date).format('YYYY-MM-DD'),
          start_time: normalizeTime(data.start_time),
          end_time: normalizeTime(data.end_time),
          break_start_time: normalizeTime(data.break_start_time),
          break_end_time: normalizeTime(data.break_end_time),
        }
      }
      return {}
    },
    updateTask(fromDraggedMethod = false) {
      if (this.formValidation()) return;
      this.loading = true;
      const idx = this.tasks.findIndex(t => t.id === this.form.id);
      if (idx !== -1 && this.form.id) {
        const url = apiUrl + this.actl + '/' + this.editUrl + '/' + this.form.id + '.json'
        const postData = this.preparePostData(this.form)
        console.log('postData', postData)

        this.$axios.post(url, postData)
            .then(response => {
              console.log('response', response)
              const responseData = response.data.response
              if (response.status === 200 && responseData.status === true) {
                const updatedTask = this.prepareTaskData(responseData.data);
                // Preserve id and ensure reactivity by using splice
                if (!fromDraggedMethod) {
                  this.tasks.splice(idx, 1, { ...this.tasks[idx], ...updatedTask });
                }
              }else {
                this.apiErrorMsg = responseData.msg
              }
            })
            .catch(error => {
              console.log('error', error)
            })
            .finally(() => {
              this.loading = false;
              this.showDialog = false;
              this.form = {};
            })
      } else {
        this.apiErrorMsg = 'タスクが見つかりません。';
      }
    },
    deleteTask(taskId) {
      if (!confirm('このタスクを削除してもよろしいですか?')) return;
      this.loading = true;
      const idx = this.tasks.findIndex(t => t.id === taskId);
      if (idx !== -1) {
        const url = apiUrl + this.actl + '/' + this.deleteUrl + '/' + taskId + '.json'
        this.$axios.delete(url)
            .then(response => {
              const responseData = response.data.response
              if (response.status === 200 && responseData.status === true) {
                this.tasks.splice(idx, 1);
              }else {
                this.apiErrorMsg = responseData.msg
              }
            })
            .catch(error => {
              console.log('error', error)
            })
            .finally(() => {
                  this.loading = false;
                  this.showDialog = false;
                  this.form = {};
            })
      } else {
        this.apiErrorMsg = 'タスクが見つかりません。';
      }
    },
    preparePostData(formData) {
      return {
        name: formData.name,
        worker_name: formData.worker_name,
        task_date: formData.task_date,
        start_time: formData.start_time,
        end_time: formData.end_time,
        break_start_time: formData.break_start_time,
        break_end_time: formData.break_end_time,
      }
    },
    updateDraggedTask(task) {
      // When a bar is dragged/resized, update the task in our list
      const idx = this.tasks.findIndex(t => t.id === task.id);
      if (idx !== -1) {
        this.tasks.splice(idx, 1, { ...this.tasks[idx], ...task });
      }
      this.$nextTick(() => {
        Object.assign(this.form, task)
        this.updateTask(true)
      })
    }
  },
  watch: {
    selectedStartDate(newVal) {
      if (newVal) {
        const start = this.$moment(newVal)
        const end = this.selectedEndDate ? this.$moment(this.selectedEndDate) : null
        if (end && start.isAfter(end)) {
          this.selectedEndDate = start.toDate()
        }
      }
    },
    selectedEndDate(newVal) {
      if (newVal) {
        const start = this.selectedStartDate ? this.$moment(this.selectedStartDate) : null
        const end = this.$moment(newVal)
        if (start.isAfter(end)) {
          this.selectedStartDate = end.toDate()
        }
      }
    }
  }
}
</script>

<style scoped>
.base { position: fixed; top: 0; left: 0; right: 0; display: flex; justify-content: center; margin-top: 50px; }
.overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: gray; opacity: 0.5; }
.content { background-color: white; position: relative; border-radius: 10px; padding: 40px; }
.spinner-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; justify-content: center; align-items: center; }
.spinner { border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 2s linear infinite; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>